export const TAX_RECEIPTS_AREA_PATH = "/tax-receipts";
export const TAX_RECEIPTS_TABS = [
    {
        key: "dashboard",
        labelKey: "finance.taxReceipts.tabs.dashboard",
        path: TAX_RECEIPTS_AREA_PATH,
        routeName: "TaxReceiptsDashboard",
        requiresCapability: "opdon.read",
    },
    {
        key: "donation",
        labelKey: "finance.taxReceipts.tabs.donation",
        path: `${TAX_RECEIPTS_AREA_PATH}/donation`,
        routeName: "TaxReceiptsDonation",
        requiresCapability: "opdon.read",
    },
    {
        key: "newBatch",
        labelKey: "finance.taxReceipts.tabs.newBatch",
        path: `${TAX_RECEIPTS_AREA_PATH}/batches/new`,
        routeName: "TaxReceiptsNewBatch",
        requiresCapability: "opdon.edit",
    },
    {
        key: "batchReport",
        labelKey: "finance.taxReceipts.tabs.batchReport",
        path: `${TAX_RECEIPTS_AREA_PATH}/batches/report`,
        routeName: "TaxReceiptsBatchReport",
        requiresCapability: "opdon.read",
    },
];
/**
 * The tabs the page header shows. Only the delivered screens are listed; the others keep their
 * route (an empty page) and come back here once delivered. The breadcrumb links to the dashboard
 * only while `dashboard` is listed.
 */
export const TAX_RECEIPTS_HEADER_TAB_KEYS = [
// "dashboard",
// "donation",
// "newBatch",
// "batchReport",
];
export const TAX_RECEIPTS_TAB_BY_KEY = Object.fromEntries(TAX_RECEIPTS_TABS.map((tab) => [tab.key, tab]));
/** The tab whose path is the current one, or whose sub-path the current one is under. */
export function activeTaxReceiptsTab(currentPath) {
    const match = TAX_RECEIPTS_TABS.filter((tab) => currentPath === tab.path || currentPath.startsWith(`${tab.path}/`)).sort((a, b) => b.path.length - a.path.length)[0];
    return match?.key ?? null;
}
